<template>
<RouterLink 
    :to="to" 
    class="text-gray-600 hover:text-gray-900 transition-colors font-bold uppercase"
    :class="{ 'block py-2 px-4 text-black hover:bg-gray-50 rounded-lg text-2xl': isMobile }"
    @click="closeMenu"
    >
    {{ label }}
</RouterLink>
</template>

<script lang="ts" setup>
import { useNavigation } from '../composables/useNavigation';

const { closeMenu } = useNavigation();

defineProps<{
    label: string;
    to: string;
    isMobile?: boolean;
}>();
</script>